var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.news
    ? _c(
        "div",
        { staticClass: "intl-news-detail" },
        [
          _c("IntlBreadcrumb", { attrs: { "detail-title": _vm.newsTitle } }),
          _vm._v(" "),
          _c("div", { staticClass: "intl-news-detail__head" }, [
            _c("h1", { staticClass: "intl-news-detail__title" }, [
              _vm._v(_vm._s(_vm.newsTitle)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "intl-news-detail__meta" }, [
              _c("span", [_vm._v(_vm._s(_vm.news.date))]),
              _vm._v(" "),
              _c("span", { staticClass: "sep" }, [_vm._v("·")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.newsSource))]),
              _vm._v(" "),
              _c("span", { staticClass: "sep" }, [_vm._v("·")]),
              _vm._v(" "),
              _vm.news.categoryLabel
                ? _c("span", { staticClass: "tag" }, [
                    _vm._v(_vm._s(_vm.news.categoryLabel)),
                  ])
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "intl-news-detail__body",
            domProps: { innerHTML: _vm._s(_vm.newsContent) },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "intl-news-detail__back" },
            [
              _c("router-link", { attrs: { to: "/international/news" } }, [
                _vm._v(_vm._s(_vm.$t("common.back"))),
              ]),
            ],
            1
          ),
        ],
        1
      )
    : _c("div", { staticClass: "intl-news-detail__loading" }, [
        _vm._v(
          "\n  " +
            _vm._s(
              _vm.loadFailed
                ? _vm.$t("common.contentUnavailable")
                : _vm.$t("common.loading")
            ) +
            "\n"
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }